import { FormSetting } from '@/form-settings/form-setting';

export class VehicleAccessoryFormSetting extends FormSetting {
  protected static classToCall: string;

  public static setClassToCall(classes) {
    this.classToCall = classes;

    return this;
  }

  public static getMeta(): Array<any> {
    return [
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'anagSiglaModello',
            label: 'Modello',
            controlType: 'autocomplete-model',
            class: 'lg:w-6/12 w-full',
            order: 1,
            required: true,
            options: this.get('modelsAnag'),
          },
          {
            classToUse: this.classToCall,
            key: 'descrizioneAccessorio',
            label: 'Descrizione accessorio',
            controlType: 'textinput',
            class: 'lg:w-12/12 w-full',
            order: 1,
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'codiceAccessorio',
            label: 'Codice',
            controlType: 'textinput',
            class: 'lg:w-3/12 w-full',
            order: 1,
            required: false,
          },
          {
            classToUse: this.classToCall,
            key: 'prezzo',
            label: 'Importo',
            controlType: 'number',
            class: 'lg:w-3/12 w-full',
            order: 1,
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'provvigione',
            label: 'Provvigione',
            controlType: 'number',
            class: 'lg:w-3/12 w-full',
            order: 1,
          },
          {
            classToUse: this.classToCall,
            key: 'enabled',
            controlType: 'slide-toggle',
            label: 'Abilitato',
            default: true,
            order: 1,
            class: 'lg:w-3/12 w-full',
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'id',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
          {
            classToUse: this.classToCall,
            key: 'creator',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
        ],
        order: 1,
      },
    ];
  }
}
